

















import Vue from 'vue';

export default Vue.extend({
    props: {
        items: {
            type: Array,
            required: true,
        },
        active: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            visble: false,
        };
    },
    mounted() {
        window.addEventListener('scroll', this.scrollFn);
    },
    methods: {
        select(idx) {
            this.$emit('select', idx);
        },
        add() {
            this.$router.push({
                path: '/products',
            });
        },
        scrollFn() {
            this.visble = document.documentElement.scrollTop > 30;
        },
        top() {
           window.scrollTo(0, 0);
        },
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollFn); // 销毁监听
    },
});

